
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_o08jm_1jxyl_9",
  "root-horizontal": "awsui_root-horizontal_o08jm_1jxyl_41",
  "root-vertical": "awsui_root-vertical_o08jm_1jxyl_46",
  "layout": "awsui_layout_o08jm_1jxyl_51",
  "action-slot": "awsui_action-slot_o08jm_1jxyl_56",
  "layout-horizontal": "awsui_layout-horizontal_o08jm_1jxyl_64",
  "layout-vertical": "awsui_layout-vertical_o08jm_1jxyl_71",
  "control": "awsui_control_o08jm_1jxyl_79",
  "control-middle-horizontal": "awsui_control-middle-horizontal_o08jm_1jxyl_86",
  "control-last-horizontal": "awsui_control-last-horizontal_o08jm_1jxyl_86",
  "control-middle-vertical": "awsui_control-middle-vertical_o08jm_1jxyl_89",
  "control-last-vertical": "awsui_control-last-vertical_o08jm_1jxyl_89"
};
  